import services from 'services/module';

export class EventSvc {
    constructor(private $rootScope: ng.IRootScopeService,
                private $state: ng.ui.IStateService,
                private $log: ng.ILogService) {
    }

    init() {
        this.$rootScope.$on('$stateChangeStart', (event: ng.IAngularEvent,
                                                  toState: ng.ui.IState,
                                                  toParams: ng.ui.IStateParamsService,
                                                  fromState: ng.ui.IState) => {
            //remove all listeners on page change. Can be dangerous, watch out!
            const hasTemplate = fromState.templateUrl
                || fromState.template
                || toState.templateUrl
                || toState.template;

            const isStateProject = () =>
                options.animatronProducts.some((product) =>
                    this.$state.is(`${product.toLowerCase()}-project`));

            if (!isStateProject() && hasTemplate) {
                const listeners = this.$rootScope.$$listeners;
                Object.keys(listeners)
                    .filter(l => l.lastIndexOf('$', 0) !== 0 && listeners[l].length > 0)
                    .forEach(listener => {
                        this.$log.debug('Removing listener', listener);
                        listeners[listener] = [];
                    });
            }
        });
    }
}
services.service('EventSvc', EventSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/EventSvc.ts